import React from 'react';
import ContentLayout from '../../../../components/ContentLayout';
import props from '../../../../lib/contentLayoutProps/learning-at-kingston/primary-school/layoutProps';

import image from './bilingual@large.jpg';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="our-bilingual-approach">
    <h1>Our Bilingual Approach</h1>
    <p>
      The bilingual nature of our programme makes it truly unique. Putonghua and English are the languages of
      instruction at Kingston with the expectations that students work and participate in both languages.
    </p>
    <p>
      Each class has one native speaking fully-qualified Putonghua teacher and one native speaking fully-qualified
      English teacher. Each day students spend a portion of the day immersed in English and a portion immersed in
      Putonghua with the rest of the day spent working in both languages.
    </p>
    <p>
      The Kingston bilingual experience begins as early as playgroup and continues through to Primary 6. We are very
      proud of our students' abilities in both languages. We provide the perfect environment for native fluency in both
      English and Putonghua. Our small class numbers and high teacher-to-student ratio form the cornerstone of our
      bilingual approach, which is delivered through the IBPYP framework.
    </p>
    <img src={image} alt="Our bilingual approach" />
  </ContentLayout>
);
